<template>
  <template v-if="!isPreConsultationScreen">
    <!-- External Camera -->
    <AddExternalCameraButton />
    <!-- Stethoscope -->
    <AddStethoscopeButton />
    <!-- Otoscope -->
    <AddOtoscopeButton />
    <!-- Dermatoscope -->
    <AddDermatoscopeButton />
    <!-- Monitor -->
    <AddMonitorButton />
    <!-- External Devices dropdown -->
    <!-- <AddExternalDevicesButton />-->
  </template>

  <!-- SmartGlass -->
  <div v-if="!isPreConsultationScreen" class="relative group">
    <!-- Todo: Create AddSmartglassesButton.vue and delete DeviceBadge -->
    <DeviceBadge
      :loading="StreamingDevicesStore.devices.smartglasses.disconnecting"
      :data-cy="`show-smartglass-modal-${StreamingDevicesStore.devices.smartglasses.connected}`"
      @click="handleSmartglassesConnection"
      :class="{ 'pointer-events-none': StreamingDevicesStore.devices.smartglasses.disconnecting }"
      :isActive="StreamingDevicesStore.devices.smartglasses.connected"
      :btnDescription="
        StreamingDevicesStore.devices.smartglasses.connected
          ? 'Disconnect Smart-glasses'
          : 'Connect Smart-glasses'
      "
      icon="Glasses"
      :options="['Configure wifi']"
    />
  </div>

  <!-- Smartphone -->
  <div v-if="!isPreConsultationScreen" class="relative group">
    <DeviceBadge
      :loading="StreamingDevicesStore.devices.smartphone.disconnecting"
      :data-cy="`show-smartphone-modal-${StreamingDevicesStore.devices.smartphone.connected}`"
      @click="handleSmartphoneConnection"
      :class="{ 'pointer-events-none': StreamingDevicesStore.devices.smartphone.disconnecting }"
      :isActive="StreamingDevicesStore.devices.smartphone.connected"
      :btnDescription="
        StreamingDevicesStore.devices.smartphone.connected
          ? 'Disconnect Smartphone'
          : 'Connect Smartphone'
      "
      icon="Phone"
    />
  </div>
</template>

<script>
import { computed } from 'vue';

import useSessionStore from '@/Stores/useSessionStore';
import useIOTDevicesStore from '@/Stores/useIOTDevicesStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import DeviceBadge from '@/Components/Badges/DeviceBadge.vue';
import AddMonitorButton from '@/Components/Buttons/AddMonitorButton.vue';
import { DISPLAY_NAME, VICE_SESSION_PHASES } from '@/Utils/vice-constants';
import AddOtoscopeButton from '@/Components/Buttons/AddOtoscopeButton.vue';
import useSmartphoneScreenshare from '@/Composables/useSmartphoneScreenshare';
import AddStethoscopeButton from '@/Components/Buttons/AddStethoscopeButton.vue';
import AddDermatoscopeButton from '@/Components/Buttons/AddDermatoscopeButton.vue';
import AddExternalCameraButton from '@/Components/Buttons/AddExternalCameraButton.vue';

export default {
  props: {},
  components: {
    DeviceBadge,
    AddMonitorButton,
    AddOtoscopeButton,
    AddStethoscopeButton,
    AddDermatoscopeButton,
    AddExternalCameraButton,
  },
  setup() {
    const sessionStore = useSessionStore();
    const StreamingDevicesStore = useIOTDevicesStore();
    const smartphoneScreenshare = useSmartphoneScreenshare();
    const multiCameraDevicesStore = useLocalStreamingDevicesStore();

    const toggleDeviceStream = (deviceId) => {
      StreamingDevicesStore.toggleDeviceStreamLoading(deviceId);
      setTimeout(() => {
        StreamingDevicesStore.toggleDeviceStream(deviceId);
      }, 1000);
    };

    // Todo: Consider creating a global currentScreen variable
    const isPreConsultationScreen = computed(
      () =>
        sessionStore.currentPhase === VICE_SESSION_PHASES.CONSULTATION &&
        !sessionStore.hasLivePhase,
    );
    const handleSmartglassesConnection = async () => {
      sessionStore.toggleControlPanel(true);

      if (StreamingDevicesStore.devices.smartglasses.connected) {
        await sessionStore.deviceMessageSender.turnOffSmartGlass();
        StreamingDevicesStore.devices.smartglasses.connected = false;
        multiCameraDevicesStore.removeExternalDevicePreview(DISPLAY_NAME.VUZIX);
      } else if (isPreConsultationScreen.value) {
        multiCameraDevicesStore.openPreviewModal('smartGlass');
      } else {
        StreamingDevicesStore.openSmartGlassesModal();
      }
    };

    const handleSmartphoneConnection = () => {
      sessionStore.toggleControlPanel(true);

      if (StreamingDevicesStore.devices.smartphone.connected) {
        smartphoneScreenshare.stopSmartphoneStream(true);
        StreamingDevicesStore.devices.smartphone.connected = false;
      } else if (isPreConsultationScreen.value) {
        multiCameraDevicesStore.openPreviewModal('smartphone');
      } else {
        smartphoneScreenshare.connect();
        StreamingDevicesStore.openSmartphoneModal();
      }
    };

    return {
      toggleDeviceStream,
      handleSmartphoneConnection,
      handleSmartglassesConnection,
      StreamingDevicesStore,
      isPreConsultationScreen,
      multiCameraDevicesStore,
    };
  },
};
</script>
